import "./Atelier.module.css";
import StudioThorneHeader from "@/reusable_sections/Header";
import TheThornePhilosophy from "./sections/TheThornePhilosophy";
import TheThorneMethodology from "./sections/TheThorneMethodology";
import StudioThorneFooter from "@/reusable_sections/Footer";
export default function AtelierPage() {
  return <div>
      <StudioThorneHeader />
      <TheThornePhilosophy />
      <TheThorneMethodology />
      <StudioThorneFooter />
    </div>;
}